import { Box, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { TEXT_VARIANTS } from "@/theme/components/text";

export type ListWithLabelProps = {
  points: { label?: string; text: string }[];
  separator?: string;
  textColor?: string;
};

const ListWithLabel = (props: ListWithLabelProps) => {
  const { points, separator = ":", textColor = "text.100" } = props;
  const textVariant = TEXT_VARIANTS.BODY2;
  return (
    <Box>
      <UnorderedList>
        {points.map((point, index) => {
          const { text, label } = point;
          return (
            <ListItem color={textColor} key={index}>
              {label && (
                <Text as="span" fontWeight={600} variant={textVariant}>
                  {`${label} ${separator} `}
                </Text>
              )}

              <Text as="span" variant={textVariant}>
                {text}
              </Text>
            </ListItem>
          );
        })}
      </UnorderedList>
    </Box>
  );
};

export default ListWithLabel;
